import { render, staticRenderFns } from "./PortalMessage.vue?vue&type=template&id=da186bfa&scoped=true&"
import script from "./PortalMessage.vue?vue&type=script&lang=ts&"
export * from "./PortalMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da186bfa",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da186bfa')) {
      api.createRecord('da186bfa', component.options)
    } else {
      api.reload('da186bfa', component.options)
    }
    module.hot.accept("./PortalMessage.vue?vue&type=template&id=da186bfa&scoped=true&", function () {
      api.rerender('da186bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shared/shared/components/PortalMessage.vue"
export default component.exports